import { Box, Button } from '@mui/material';
import React from 'react';

interface ActionButtonsStrategyFooterProps {
    onClose: () => void;
    status: string;
    revertHidden: boolean;
    approveHidden: boolean;
    handleRevert: () => void;
    handleApprove: (id: any) => void;
    id: any;
    cancelButtonText?: string;
    revertButtonText?: string;
    approveButtonText?: string;
    cancelButtonColor?: string;
    revertButtonColor?: string;
    approveButtonColor?: string;
  }
  
  const ActionButtonsStrategyFooter: React.FC<ActionButtonsStrategyFooterProps> = ({
    onClose,
    status,
    revertHidden,
    approveHidden,
    handleRevert,
    handleApprove,
    id,
    cancelButtonText = 'Cancel',
    revertButtonText = 'Revert',
    approveButtonText = 'Approve',
    cancelButtonColor = '#000',
    revertButtonColor = '#D90000',
    approveButtonColor = '#058B2B',
  }) => {
    return (
      <Box
        // position="fixed"
        // bottom={0}
        // padding={2}
        // width="50%"
        sx={{
          // boxShadow: '-1px -1px 13.2px 0px rgba(0, 0, 0, 0.1)',
          // bgcolor: '#fff',
          // zIndex: 10,
          display: 'flex',
          justifyContent: 'end',
        }}
      >
        {/* <Box>
          <Button
            variant="outlined"
            sx={{ color: cancelButtonColor, borderColor: cancelButtonColor }}
            onClick={onClose}
          >
            {cancelButtonText}
          </Button>
        </Box> */}
  
        <Box
          sx={{ display: 'flex', gap: '20px', justifyContent: 'end', marginRight: '20px' }}
        >
          {status !== 'Reverted' && status !== 'Approved' && (
            <>
              {!revertHidden && (
                <Button
                  variant="outlined"
                  sx={{
                    color: revertButtonColor,
                    padding: '7px 35px',
                    textTransform: 'none',
                    border: `1px solid ${revertButtonColor}`,
                  }}
                  onClick={handleRevert}
                >
                  {revertButtonText}
                </Button>
              )}
  
              {!approveHidden && (
                <Button
                  variant="contained"
                  sx={{
                    color: '#fff',
                    padding: '7px 35px',
                    textTransform: 'none',
                    bgcolor: approveButtonColor,
                  }}
                  onClick={() => handleApprove(id)}
                >
                  {approveButtonText}
                </Button>
              )}
            </>
          )}
        </Box>
      </Box>
    );
  };
  
  export default ActionButtonsStrategyFooter;